import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { MAIN_MOCKUP, offerItems } from '../data/breakFreeContent';
export function OfferSection() {
  return <section id="offer" className="w-full border-y border-champagne/25 bg-black py-12 sm:py-16" aria-labelledby="offer-title" data-id="element-116" data-mp="8lu8e6onpcuv">
      <div className="mx-auto max-w-4xl px-5" data-id="element-117" data-mp="idi1ec0v31yg">
        <h2 id="offer-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-118" data-mp="icor512p1ubk">
          Everything you need to break free.
        </h2>

        <div className="mt-8 grid items-center gap-8 sm:grid-cols-2 sm:gap-10" data-id="element-119" data-mp="wczj67fqpeyb">
          <img src={MAIN_MOCKUP} alt="The complete BREAK FREE™ system — six volumes and six exclusive bonuses" className="mx-auto w-full max-w-[16rem]" width={1080} height={1350} data-id="element-120" data-mp="wawupru8jtvp" />

          <div data-id="element-121" data-mp="12ojzklxzckqi">
            <ul className="space-y-2" data-id="element-122" data-mp="12oa5on9tdtfj">
              {offerItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-123" data-mp="xvqtnuqrz6cu">
                  <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-124" data-mp="sxfk7l4e6xv5" />
                  <span className="text-[14px] leading-snug text-ivory-100" data-id="element-125" data-mp="1lm4ep1ay04xx">{item}</span>
                </li>)}
            </ul>

            <dl className="mt-6 space-y-1 border-t border-charcoal-600 pt-5 text-[12px] uppercase tracking-[0.12em]" data-id="element-126" data-mp="1gokznz6f7o4x">
              <div className="flex items-baseline justify-between text-muted" data-id="element-127" data-mp="1cjv64gz8iln6">
                <dt data-id="element-128" data-mp="17ltlvsq2oga4">Total value</dt>
                <dd data-id="element-129" data-mp="17oxvx6q7y68p">$674</dd>
              </div>
              <div className="flex items-baseline justify-between text-muted" data-id="element-130" data-mp="17kisq39fhq4">
                <dt data-id="element-131" data-mp="3scaudb0tbpqg">Regular price</dt>
                <dd className="line-through" data-id="element-132" data-mp="3sb98scm67kuh">$197</dd>
              </div>
            </dl>

            <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.24em] text-champagne" data-id="element-133" data-mp="3tvauc4bu9ed7">
              Today
            </p>
            <p className="font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-134" data-mp="2lc7jv7mkvhp">
              $27
              <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-135" data-mp="3oumv4vdghr7w">
                USD
              </span>
            </p>

            <div className="mt-6" data-id="element-136" data-mp="3b1ot4q6id0vd">
              <CtaButton target="checkout" size="md" label="Get BREAK FREE™ now →" data-id="element-137" data-mp="3fuhy9f5w2b7z" />
            </div>
            <TrustStrip className="mt-3 sm:justify-start" data-id="element-138" data-mp="313hiep2tbf1t" />
          </div>
        </div>
      </div>
    </section>;
}